// @ts-nocheck
import React from 'react'
import styles from './CardTable.module.scss'
import cx from 'classnames'

export const CardTable = ({ children, bodyClassName, tableClassName }) => (
  <table className={cx(styles.table, tableClassName)}>
    <tbody className={cx(styles.tableBody, bodyClassName)}>{children}</tbody>
  </table>
)
